import React from 'react'
import { useNavigate } from 'react-router-dom'
import { collection, addDoc, doc, setDoc } from 'firebase/firestore'
import { useError, useForm } from '../../hooks'
import { db } from '../../firebase'

import TextField from '../Form/TextField'
import ColorField from '../Form/ColorField'
import IconField from '../Form/IconField'
import CheckboxField from '../Form/CheckboxField'
import Button from '../Button'
import ContextMenu from '../ContextMenu'

export const USER_TYPE_FLAGS = {
  DISPATCHABLE: 1 << 0,
  FORCE_BACKGROUND_LOCATION: 1 << 1,
  SECURITY_LEADER: 1 << 2,
  CITIZEN_PANIC_BUTTON: 1 << 3
}

export function parseUserTypeFormData(formData) {
  const {
    name,
    icon,
    color,
    dispatchable,
    backgroundLocation,
    securityLeader,
    citizenPanicButton
  } = formData
  let flags = 0
  if (dispatchable) flags |= USER_TYPE_FLAGS.DISPATCHABLE
  if (backgroundLocation) flags |= USER_TYPE_FLAGS.FORCE_BACKGROUND_LOCATION
  if (securityLeader) flags |= USER_TYPE_FLAGS.SECURITY_LEADER
  if (citizenPanicButton) flags |= USER_TYPE_FLAGS.CITIZEN_PANIC_BUTTON

  return {
    name,
    icon,
    color,
    flags
  }
}

export function UserTypeForm({ defaultValue, getFieldProps }) {
  defaultValue = defaultValue || {}

  return (
    <div>
      <TextField
        label='Name'
        name='name'
        placeholder='Name'
        defaultValue={defaultValue.name}
        required
        {...getFieldProps()}
      />
      <IconField
        label='Icon'
        name='icon'
        iconColor={defaultValue.color || '#000000'}
        defaultValue={defaultValue.icon}
        required
        {...getFieldProps()}
      />
      <ColorField
        label='Color'
        name='color'
        required
        defaultValue={defaultValue.color}
        {...getFieldProps()}
      />
      <label className='label has-text-info'>Settings</label>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <CheckboxField
          label='Dispatchable'
          name='dispatchable'
          defaultChecked={defaultValue.dispatchable}
          {...getFieldProps()}
        />
        <CheckboxField
          label='Force background location'
          name='backgroundLocation'
          defaultChecked={defaultValue.backgroundLocation}
          {...getFieldProps()}
        />
        <CheckboxField
          label='Security leader'
          name='securityLeader'
          defaultChecked={defaultValue.securityLeader}
          {...getFieldProps()}
        />
        <CheckboxField
          label='Citizen panic button'
          name='citizenPanicButton'
          defaultChecked={defaultValue.citizenPanicButton}
          {...getFieldProps()}
        />
      </div>
    </div>
  )
}

export default function CreateUserType() {
  const navigate = useNavigate()
  const setError = useError()
  const [getFieldProps, formData, formError] = useForm()

  async function handleSubmit(e) {
    e.preventDefault()

    try {
    const parsedData = parseUserTypeFormData(formData)
    
    const newDocRef = doc(collection(db, 'userTypes')) // Create ref with auto-generated ID
    const dataWithId = { ...parsedData, id: newDocRef.id } // Add the ID to the data

    await setDoc(newDocRef, dataWithId) // Save with ID inside the document

    navigate(`/system/user-types/${newDocRef.id}`)
  } catch (err) {
      console.error('Error creating user type:', err)
      setError(err)
    }
  }

  return (
    <div className='box'>
      <form onSubmit={handleSubmit}>
        <UserTypeForm getFieldProps={getFieldProps} />
        <br />
        {/* <ContextMenu> */}
          <Button type='submit'>Create</Button>
        {/* </ContextMenu> */}
      </form>
    </div>
  )
}
